<template>
  <div class="container">
    <div class="search-container">
      <input type="text" :placeholder="$t('stock.productNoTip')" v-model="productNo" @keydown.enter="performSearch" />
      <button class="search-button" @click="performSearch">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M15.5 14h-.79l-.28-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
      </button>
    </div>

    <div class="scan-container">
      <div class="scan-item">
        <!-- <input type="file" accept="image/*" capture="camera" @change="handleFileChange" ref="fileInput" style="display:none" />
        <img src="../../assets/tack_photo18.png" :alt="$t('stock.ocr')" /> -->
        <p class="scan-text">{{ $t('stock.ocrText') }}<br/><span>{{ $t('stock.ocr') }}</span></p>
      </div>
    </div>

    <!-- 加载动画 -->
    <div v-if="isLoading" class="loading-spinner">
      <div class="spinner"></div>
      <p style="color: #265bc6; font-weight: 500;">Recognizing Product No.</p>
    </div>

    <!-- <div v-if="imageUrl" class="image-preview">
      <img :src="imageUrl" alt="Uploaded Image" ref="uploadedImage" />
    </div>
    <div v-if="ocrResult" class="ocr-result">
      <h3>识别结果:</h3>
      <pre>{{ ocrResult }}</pre>
    </div>
    <canvas ref="canvas" style="display: none"></canvas>
    
    <div v-if="errorMessage">
      <h3>错误：</h3>
      <p>{{ errorMessage }}</p>
    </div> -->
  </div>
</template>

<script>
// import { createCanvas, loadImage } from 'canvas';
import Tesseract from 'tesseract.js';

export default {
  name: 'OCR',
  data() {
    return {
      productNo: '',
      errorMessage: '',
      imageUrl: null,  // 存储上传的图片URL
      ocrResult: null,  // 存储OCR识别结果
      isLoading: false,  // 增加加载状态
    };
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();  // 触发文件输入框点击事件
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = async (event) => {
          this.imageUrl = event.target.result;  // 创建图片URL用于预览
          // await this.preprocessImage(event.target.result);
          await this.performOCR();  // 执行OCR识别
        };
        reader.onerror = (error) => {
          this.errorMessage = `FileReader error: ${error}`;
          console.error('FileReader error:', error);
        };
        reader.readAsDataURL(file);
      } else {
        console.log('No file selected.');
      }
    },
    async performOCR() {
      if (!this.imageUrl) {
        this.errorMessage = `No image to perform OCR.`;
        console.log('No image to perform OCR.');
        return;
      }

      this.isLoading = true;  // 开始加载动画

      // Tesseract.setOcrStrategy(Tesseract.OcrStrategy.AUTO); // 设置OCR策略

      Tesseract.recognize(
        this.imageUrl,
        'eng',
        {
          logger: m => console.log(m),  // 日志输出
          // tessedit_char_whitelist: '0123456789',
          // tessedit_ocr_engine_mode: Tesseract.OEM.LSTM_ONLY, // 设置OCR引擎模式
          psm: 6,
          user_defined_dpi: '300', // 设置图像DPI
          // enable_new_segsearch: '1',
        }
      ).then((result) => {
        console.log('OCR Result:', result);
        // 对识别结果进行置信度过滤
        // const textWithConfidence = result.data.words.map(word => {
        //   if (word.confidence > 80) { // 置信度阈值可以根据需要调整
        //     return word.text;
        //   }
        //   // return ''; // 置信度低的字符被过滤掉
        // });
        // console.log('M-置信度（高） ', textWithConfidence);

        // this.ocrResult = result.data.text;  // 获取OCR识别结果
        const text = result.data.text;
        const productNo = this.matchProductNo(text);
        if (productNo) {
          this.$router.push({
            name: 'productInventoryDetails',
            query: {
              code: productNo,
              lang: process.env.VUE_APP_LANG,
              loc: process.env.VUE_APP_LOC
            }
          });
          // window.location.href = `https://wechat.vitalitytex.com.cn/wap/modelclass/detail?code=${productNo}&lang=${process.env.VUE_APP_LANG}&loc=${process.env.VUE_APP_LOC}`;
        } else {
          this.$message({
            message: `${localStorage.getItem('lang') == 'zh' ? '产品号识别失败，请尝试将拍照的清晰度提高（如放大标签），并重试。' : 'Product No. recognition failed. Please try to improve the clarity of the photo (e.g., by zooming in on the label) and retry.'}`,
            type: 'error',
            duration: 20000
          });
        }
      }).catch((error) => {
        console.error('OCR error:', error);
      }).finally(() => {
        this.isLoading = false;  // 停止加载动画
      });
    },
    
    performSearch() {
      // if (this.productNo) window.location.href = `https://wechat.vitalitytex.com.cn/wap/modelclass/detail?code=${this.productNo}&lang=${process.env.VUE_APP_LANG}&loc=${process.env.VUE_APP_LOC}`;
      if (this.productNo) {
        this.$router.push({
          name: 'productInventoryDetails',
          query: {
            code: this.productNo,
            lang: process.env.VUE_APP_LANG,
            loc: process.env.VUE_APP_LOC
          }
        });
      }
    },
    matchProductNo(text) {
      const regex_STB = /[0-9]{5}\/[0-9]{3}/gm; // 9位数字，且第六位是/
      const regex_TGO = /1[0-9]{4}|2[0-9]{4}/; // 5位数字，且是1或2开头
      const regex = /\b\d{9}\b/; // 不包含 / 的9位数字

      if (regex_STB.test(text)) {
        return text.match(regex_STB)[0];  // 优先匹配 regex_STB
      } else if (regex.test(text)) {
        // 解决将产品号中的 / 识别为 1 的情况。规则：如果存在9位的数字且不包含 / 则将第5位替换为 /
        const match = text.match(regex);
        let _text = match && match.length > 0 && match[0][5] == '1' ? `${match[0].slice(0, 5)}/${match[0].slice(6)}` : null;
        return _text;
      } else if (regex_TGO.test(text)) {
        return text.match(regex_TGO)[0];  // 如果不匹配 regex_STB，则匹配 regex_TGO
      } else {
        return null;  // 如果都不匹配，返回 null
      }
    },

    // 图像处理函数
    preprocessImage(imageSrc) {
      let _this = this;
      const image = new Image();
      image.src = imageSrc;
      image.onload = async () => {
        const canvas = this.$refs.canvas;
        const ctx = canvas.getContext('2d');
        let width = image.width;
        let height = image.height;

        if (width < 1000 || height < 1000) {
          // 增加图像分辨率
          width = width * 2;
          height = height * 2;
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(image, 0, 0, width, height);

        let imageData = ctx.getImageData(0, 0, width, height);
        let data = imageData.data;

        // 灰度化
        for (let i = 0; i < data.length; i += 4) {
          const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
          data[i] = avg;
          data[i + 1] = avg;
          data[i + 2] = avg;
        }

        ctx.putImageData(imageData, 0, 0);

        // 二值化
        imageData = ctx.getImageData(0, 0, width, height);
        data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          const brightness = data[i];
          const binaryColor = brightness > 128 ? 255 : 0;
          data[i] = binaryColor;
          data[i + 1] = binaryColor;
          data[i + 2] = binaryColor;
        }

        ctx.putImageData(imageData, 0, 0);

        // 去噪
        imageData = ctx.getImageData(0, 0, width, height);
        data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          if (data[i] === 255 && data[i + 1] === 255 && data[i + 2] === 255) {
            const neighbors = [
              data[i - 4], data[i + 4], // 左右
              data[i - width * 4], data[i + width * 4], // 上下
            ].filter(value => value !== undefined);

            if (neighbors.every(value => value === 0)) {
              data[i] = 0;
              data[i + 1] = 0;
              data[i + 2] = 0;
            }
          }
        }

        ctx.putImageData(imageData, 0, 0);

        // 提高对比度
        imageData = ctx.getImageData(0, 0, width, height);
        data = imageData.data;
        const factor = (259 * (255 + 255)) / (255 * (259 - 255));
        // const factor = (259 * (128 + 255)) / (255 * (259 - 128));

        for (let i = 0; i < data.length; i += 4) {
          data[i] = factor * (data[i] - 128) + 128;
          data[i + 1] = factor * (data[i + 1] - 128) + 128;
          data[i + 2] = factor * (data[i + 2] - 128) + 128;
        }

        // 形态学处理（膨胀）
        imageData = ctx.getImageData(0, 0, width, height);
        data = imageData.data;
        const dstData = new Uint8ClampedArray(data);
        for (let y = 1; y < height - 1; y++) {
          for (let x = 1; x < width - 1; x++) {
            const index = _this.getPixelIndex(x, y, width);

            // Check neighbors
            let maxPixel = 0;
            for (let dy = -1; dy <= 1; dy++) {
              for (let dx = -1; dx <= 1; dx++) {
                  const neighborIndex = _this.getPixelIndex(x + dx, y + dy, width);
                  maxPixel = Math.max(maxPixel, data[neighborIndex]);
              }
            }

            dstData[index] = maxPixel;
            dstData[index + 1] = maxPixel;
            dstData[index + 2] = maxPixel;
            dstData[index + 3] = data[index + 3]; // Preserve alpha
          }
        }
        
        ctx.putImageData(imageData, 0, 0);

        this.imageUrl = canvas.toDataURL();
        await this.performOCR();  // 执行OCR识别
      };
      image.onerror = (error) => {
        this.errorMessage = `Image load error: ${error}`;
        console.error('Image load error:', error);
      };
    },
    getPixelIndex(x, y, width) {
      return (y * width + x) * 4;
    },

  }
};
</script>

<style scoped>
.app-main {
  padding: 0 !important;
}

.container {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  height: 100vh;
  padding: 0 20px;
  background-color: #f9f9f9;
}

.search-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100vw - 80px);
  margin: 100px 0;
  padding: 5px 10px;
  border-radius: 25px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.search-container input {
  flex: 1;
  border: none;
  outline: none;
  padding: 10px;
  font-size: 16px;
  border-radius: 20px;
  margin-right: 10px;
}

.search-container .search-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0; /* 去掉内边距 */
  /* padding: 10px; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-container .search-button svg {
  fill: #265bc6;
  pointer-events: none; /* 确保SVG图标不影响按钮点击事件 */
}

/* 针对不同状态去掉阴影和边框 */
.search-button:focus {
  outline: none; /* 去掉按钮获得焦点时的默认边框 */
}

.search-button:active {
  outline: none; /* 去掉按钮被点击时的默认边框 */
  box-shadow: none; /* 去掉按钮被点击时的阴影 */
}

/* 针对不同浏览器的兼容性处理 */
.search-button::-moz-focus-inner {
  border: 0; /* Firefox中去掉按钮获得焦点时的内边距 */
}

.search-button:focus-visible {
  outline: none;
}

/* 扫描入口 */
.scan-container {
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  -o-transform: translate(-50%, -70%);
  -ms-transform: translate(-50%, -70%);
  -moz-transform: translate(-50%, -70%);
  -webkit-transform: translate(-50%, -70%); */
  text-align: center;
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.scan-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
}

.scan-item:not(:last-child)::after {
  content: '';
  width: 1px;
  height: 80px; /* Adjust height as needed */
  background-color: #c2c2c2; /* Adjust color as needed */
  position: absolute;
  top: 20px;
  right: 0;
}

.scan-container .img-wrapper {
  width: 120px; /* 容器的宽度要比图片的宽度稍大 */
  height: 120px; /* 容器的高度要比图片的高度稍大 */
  border-radius: 50%;
  border: 2px solid #265bc6; /* 边框的颜色和宽度 */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px; /* 内间距 */
  box-sizing: border-box; /* 包括内边距和边框在内计算元素的宽度和高度 */
}

.scan-container img {
  /* width: 80px;
  height: 80px; */

  width: 120px; /* 容器的宽度要比图片的宽度稍大 */
  height: 120px; /* 容器的高度要比图片的高度稍大 */
  border-radius: 50%;
  border: 3px solid #265bc6;
  object-fit: cover;
}

.scan-text {
  text-align: center;
  margin-top: 10px;
  font-size: 18px;
  color: #265bc6;
  font-weight: bold;
}

.scan-text span {
  display: block;
  margin-top: 5px;
  font-size: 14px;
  color: #666;
}

.image-preview {
  margin-top: 20px;
}

.image-preview img {
  max-width: 100%;
  height: auto;
  border: 2px solid #265bc6;
  border-radius: 5px;
}

.ocr-result {
  margin-top: 20px;
  font-size: 18px;
  color: #333;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8); /* 半透明背景 */
  z-index: 9999;  /* 确保加载动画在最前 */
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #265bc6; /* 颜色可以根据需要调整 */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>